/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewUnauthorizedError
 */
export interface CRSFSecReviewUnauthorizedError {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewUnauthorizedError
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewUnauthorizedError
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewUnauthorizedError
     */
    title: string;
}

/**
 * Check if a given object implements the CRSFSecReviewUnauthorizedError interface.
 */
export function instanceOfCRSFSecReviewUnauthorizedError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "title" in value;

    return isInstance;
}

export function CRSFSecReviewUnauthorizedErrorFromJSON(json: any): CRSFSecReviewUnauthorizedError {
    return CRSFSecReviewUnauthorizedErrorFromJSONTyped(json, false);
}

export function CRSFSecReviewUnauthorizedErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewUnauthorizedError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
        'status': json['status'],
        'title': json['title'],
    };
}

export function CRSFSecReviewUnauthorizedErrorToJSON(value?: CRSFSecReviewUnauthorizedError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'status': value.status,
        'title': value.title,
    };
}

